


























































































































































































































































































































































































































import {
  SfAddToCart, SfLoader, SfImage, SfQuantitySelector, SfButton,
} from '~/components/StorefrontUi';
import {
  ref,
  computed,
  useContext,
  useRoute,
  useRouter,
  defineComponent,
  PropType,
  toRef,
  watch,
  onMounted,
  useFetch,
  useMeta,
} from '@nuxtjs/composition-api';
import { useStoryblokBridge } from '@storyblok/nuxt-2';
import { ISbStoryData } from '@storyblok/js/dist/types';

import { isSpecialPrice, getProductConfigurationsBySku, getProductSkuByConfigurations } from '~/modules/catalog/product/getters/productGetters';
import { getProductSchema } from '~/modules/catalog/product/helpers/schemaHelpers';

import useWishlist from '~/modules/wishlist/composables/useWishlist';
import HTMLContent from '~/components/HTMLContent.vue';
import { useUser } from '~/modules/customer/composables/useUser';
import { Product } from '~/modules/catalog/product/types';
import ProductLayout from '~/modules/catalog/product/layouts/product.vue';
import { Aggregation } from '~/modules/GraphQL/types';
import { addBasePath } from '~/helpers/addBasePath';
import ProductStickyElement from '~/modules/catalog/product/components/ProductStickyElement.vue';
import { useImage, useUiHelpers } from '~/composables';
import ProductDownloadFiles from '~/modules/catalog/product/components/ProductDownloadFiles.vue';
import ProductSection from '~/modules/catalog/product/components/ProductSection.vue';
import ProductAdditionalInfo from '~/modules/catalog/product/components/ProductAdditionalInfo.vue';
import ProductLabels from '~/components/storyblok/ProductLabels.vue';
import ProductGallery from '~/modules/catalog/product/components/ProductGallery.vue';
import AddToWishlistHeart from '~/modules/catalog/product/components/AddToWishlistHeart.vue';
import ProductVariants from '~/modules/catalog/product/components/ProductVariants.vue';
import ProductContent from '~/modules/catalog/product/components/content/ProductsContent.vue';
import ProductSliderSection from '~/modules/catalog/product/components/ProductSliderSection.vue';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import ProductContentBanners from '~/modules/catalog/product/components/content/ProductsContentBanners.vue';
import { useProductHandler } from '~/modules/catalog/product/composables/useProductHandler/useProductHandler';
import { useAddToCart } from '~/helpers/cart/addToCart';
import ProductTabsNavigation from '~/modules/catalog/product/components/ProductTabsNavigation.vue';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';

import { getMetaInfo, getUrlMeta, getMagentoMeta } from '~/helpers/getMetaInfo';
import useStoryblokView from '~/modules/storyblok/composables/useStoryblokView';
import { renderRichText } from '~/modules/storyblok/helpers/renderRichText';
import { useUserCom } from '~/modules/usercom/composables';
import { useMagentoMetaData } from '~/composables/useMagentoMetaData';
import { useRequestQuote } from '~/modules/request-quote/composables/useRequestQuote';
import { useRequestQuoteAPI } from '~/modules/request-quote/composables/useRequestQuoteAPI';
import { HandleAddProductsToQuoteCart } from '~/modules/request-quote/types';
import InfoWithIcon from '~/components/InfoWithIcon.vue';
import ProductTrustmateStars from '~/modules/catalog/product/components/ProductTrustmateStars.vue';

export default defineComponent({
  name: 'ConfigurableProduct',
  components: {
    ProductTrustmateStars,
    ProductAdditionalInfo,
    ProductTabsNavigation,
    ProductContentBanners,
    LoadWhenVisible,
    ProductSliderSection,
    ProductContent,
    ProductPrices: () => import('~/modules/catalog/product/components/ProductPrices.vue'),
    ProductsNoImage: () => import('~/modules/catalog/product/components/ProductsNoImage.vue'),
    ProductLayout,
    ProductAdditionalFields: () => import(
      '~/modules/catalog/product/components/ProductAdditionalFields.vue'
    ),
    // eslint-disable-next-line vue/no-unused-components
    HTMLContent,
    SfAddToCart,
    SfImage,
    SfButton,
    ProductStickyElement,
    ProductSection,
    ProductDownloadFiles,
    ProductLabels,
    ProductGallery,
    AddToWishlistHeart,
    SfLoader,
    ProductVariants,
    SfQuantitySelector,
    InfoWithIcon,
  },
  transition: 'fade',
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    isFetching: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    attributeValues: {
      type: Array as PropType<Aggregation[]>,
      default: () => [],
    },
  },
  setup(props, { emit, root }) {
    const product = toRef(props, 'product');
    const attributeValues = toRef(props, 'attributeValues');

    const route = useRoute();
    const router = useRouter();
    const { app, env } = useContext();
    const { alternate, xDefault, load: loadMagentoMeta } = useMagentoMetaData();
    const { isAuthenticated } = useUser();
    const { addOrRemoveItem, isInWishlist } = useWishlist();
    const {
      addItemToCart,
      loading: isCartLoading,
      canAddToCart,
    } = useAddToCart();
    const { addTags } = useCache();
    const { baseImageConfig, getMagentoImageWithConfig } = useImage();
    const { getStoryBySlug } = useStoryblokView();
    const { userComProductSegmentID, getPrediction } = useUserCom();
    const { handleAddProductsToQuoteCart } = useRequestQuote();
    const { isQuoteCartEnabled } = useRequestQuoteAPI();

    const {
      title,
      qtyConfig,
      currentProduct,
      isVariantSelected,
      productDescription,
      productShortDescription,
      finalPrice,
      finalNettoPrice,
      currentOmnibusPrice,
      available,
      productAttachments,
      isNew,
      isBestseller,
      isRecommended,
      upsellProductsSKUs,
      relatedProductsSKUs,
      isAvailableInStock,
      compositionOfFertilizer,
      productAdditionalFields,
      isOutOfStatus,
      imageSizes,
      sortedProductGallery,
      deliveryTimeLabel,
      purpose,
      czynnikiStresowe,
      substancjaCzynna,
      kondycjaRosliny,
      regeneracjaUpraw,
      aktywacjaUpraw,
      budowaniePlonuIJakosci,
      zwiekszanieOdpornosciUpraw,
      sklad,
      manufacturerLabel,
      ean,
      terminWaznosci,
      formaPakowania,
      formaTransportu,
      pakowanieHurtoweProduktu,
    } = useProductHandler(product, attributeValues);

    const hidePrice = computed(() => finalPrice.value === 0);

    const productMainImage = ref(sortedProductGallery.value[0]);
    const uiHelpers = useUiHelpers();

    const metaInfo = () => {
      const urlMeta = getUrlMeta(uiHelpers.resolvePath());
      const magentoMeta = getMagentoMeta({
        data: product.value,
        baseData: urlMeta,
        image: getMagentoImageWithConfig(
          sortedProductGallery.value[0]?.desktop?.url,
        ),
        alternate: alternate.value,
      });
      return getMetaInfo({ page: { ...magentoMeta, xDefault: xDefault.value } });
    };
    // ! We have to do it here and not in product.vue because we need product on component initialization
    // ! in order to get meta info correctly
    useMeta(() => metaInfo());

    const qty = ref(qtyConfig.value.min_sale_qty);

    const productConfiguration = ref(
      getProductConfigurationsBySku(product.value, route.value.query?.childSku as string),
    );

    const inStockVariantsSet = computed(() => {
      const arrayOfActiveIndexes = product.value.variants.flatMap((variant) => variant?.attributes.map((attribute) => `${attribute.code}${attribute.value_index}`));
      const set = new Set();
      arrayOfActiveIndexes?.forEach((index) => {
        set.add(index);
      });
      return set;
    });

    const validateConfigurableOption = (code: string, valueIndex: number) => {
      const index = `${code}${valueIndex}`;
      return inStockVariantsSet.value.has(index);
    };

    const configurableOptions = computed(
      () => product.value?.configurable_options ?? [],
    );
    const getIsVariantActive = (
      optionId: string,
      attributeId: string,
    ): boolean => productConfiguration.value[optionId] === attributeId;

    const getBaseSearchQuery = () => ({
      filter: {
        sku: {
          eq: product.value.sku,
        },
      },
      configurations: Object.entries(productConfiguration.value).map(
        (config) => config[1],
      ) as string[],
    });

    const updateProductConfiguration = (label: string, value: string) => {
      const selectedVariantSku = getProductSkuByConfigurations(product.value, label, value);
      const selectedVariantObj = { childSku: selectedVariantSku };

      if (productConfiguration.value[label] === value) return;

      productConfiguration.value[label] = value;
      const routerData = router.resolve({
        path: `${app.localePath(window.location.pathname)}`,
        query: {
          ...selectedVariantObj,
        },
      });
      window.history.pushState({}, null, routerData.href);
      emit('fetchProduct', { query: getBaseSearchQuery() });
    };

    const qtyDisabledStatus = ref(false);
    const shouldDisableCartButtons = computed(
      () => isCartLoading.value
        || !canAddToCart(product.value, qty.value)
        || props.isFetching
        || !isAvailableInStock.value,
    );
    const isMobileVariantsOpen = ref(false);
    const handleAddItemMobile = ({
      productToAdd,
      quantityToAdd,
      productConfigurationToAdd,
    }) => {
      addItemToCart({
        product: productToAdd,
        quantity: quantityToAdd,
        productConfiguration: productConfigurationToAdd,
        attributes: attributeValues.value,
      });
    };

    const productSchema = computed(() => getProductSchema({
      name: title.value,
      description: productDescription.value,
      sku: currentProduct.value?.sku || '',
      image: getMagentoImageWithConfig(sortedProductGallery.value[0]?.desktop?.url) || '',
      offer: {
        price: finalPrice.value,
        availability: available.value.stock_status,
        url: route.value.fullPath,
      },
    }));

    watch(
      () => currentProduct.value,
      () => {
        if (currentProduct.value) {
          qty.value = qtyConfig.value.min_sale_qty;
        }
      },
    );

    const recommendedProductSkus = ref([]);
    const story = ref(null);
    const isMounted = ref(false);
    onMounted(async () => {
      recommendedProductSkus.value = await getPrediction(
        env.VSF_AGRO_USER_COM_URL as string,
        userComProductSegmentID,
      );
      isMounted.value = true;
    });

    const content = ref(null);
    const banners = ref(null);
    const contentBeforePromoBlock = ref(null);
    const mainPromoBlock = ref(null);
    const isNewContent = ref(false);
    const oldDescription = ref(null);
    const isEmptyOldDescription = ref(false);
    const sectionTitle = ref(null);
    const { slug } = root.$route.params;

    const { fetch } = useFetch(async () => {
      try {
        await loadMagentoMeta();
        const { story: data } = await getStoryBySlug({
          slug: `produkt/${slug}/`,
        });
        if (!data) return;
        story.value = data;
        content.value = data.content;
        banners.value = data.content.banners;
        contentBeforePromoBlock.value = data.content.contentBeforePromoBlock;
        mainPromoBlock.value = data.content.mainPromoBlock;
        sectionTitle.value = data.content.h2_alternative || product.value.name;
        isNewContent.value = content.value?.block?.length > 0;
        oldDescription.value = typeof data.content.old_description === 'string'
          ? data.content.old_description
          : renderRichText(data.content.old_description as ISbStoryData);
        isEmptyOldDescription.value = oldDescription.value === '<p></p>';

        if (!isAuthenticated.value) {
          addTags([
            { prefix: CacheTagPrefix.View, value: story.value.full_slug },
          ]);
        }
        if (isMounted.value && story.value && story.value.id) {
          useStoryblokBridge(
            story.value.id,
            (evStory) => {
              story.value = evStory;
            },
            { preventClicks: true },
          );
        }
      } catch (error) {
        console.log('error', error);
      }
    });
    fetch();

    const selectVariantAlert = ref(false);
    const setSelectVariantAlert = () => {
      selectVariantAlert.value = true;
    };

    const handleOverlayClick = (value: boolean) => {
      isMobileVariantsOpen.value = value;
    };

    const handleAddProductsToQuoteCartClick = (productToAdd: HandleAddProductsToQuoteCart) => {
      if (!isAuthenticated.value) {
        router.push(app.localePath('/authentication'));
        return;
      }
      handleAddProductsToQuoteCart(productToAdd);
    };

    return {
      productMainImage,
      currentProduct,
      title,
      sectionTitle,
      addItemToCart,
      handleAddItemMobile,
      addItemToWishlist: addOrRemoveItem,
      canAddToCart,
      configurableOptions,
      updateProductConfiguration,
      isAuthenticated,
      isInWishlist: computed(() => isInWishlist({ product: product.value })),
      isCartLoading,
      productConfiguration,
      productShortDescription,
      qty,
      imageSizes,
      isMobileVariantsOpen,
      available,
      addBasePath,
      isSpecialPrice,
      compositionOfFertilizer,
      productDescription,
      productAttachments,
      isNew,
      isBestseller,
      isRecommended,
      finalPrice,
      finalNettoPrice,
      getIsVariantActive,
      isAvailableInStock,
      shouldDisableCartButtons,
      qtyDisabledStatus,
      isVariantSelected,
      upsellProductsSKUs,
      relatedProductsSKUs,
      productSchema,
      currentOmnibusPrice,
      qtyConfig,
      recommendedProductSkus,
      content,
      banners,
      contentBeforePromoBlock,
      mainPromoBlock,
      isNewContent,
      oldDescription,
      isEmptyOldDescription,
      baseImageConfig,
      selectVariantAlert,
      setSelectVariantAlert,
      productAdditionalFields,
      isOutOfStatus,
      sortedProductGallery,
      handleOverlayClick,
      deliveryTimeLabel,
      purpose,
      czynnikiStresowe,
      substancjaCzynna,
      kondycjaRosliny,
      regeneracjaUpraw,
      aktywacjaUpraw,
      budowaniePlonuIJakosci,
      zwiekszanieOdpornosciUpraw,
      sklad,
      handleAddProductsToQuoteCartClick,
      isQuoteCartEnabled,
      manufacturerLabel,
      ean,
      terminWaznosci,
      formaPakowania,
      formaTransportu,
      hidePrice,
      pakowanieHurtoweProduktu,
      validateConfigurableOption,
    };
  },
  head: {},
});
